import * as Styled from './CheckoutSeparator.styled';

export const CheckoutSeparator = () => (
  // biome-ignore lint/a11y/useSemanticElements: <hr /> is a void element which cannot take children.
  <Styled.Separator role="separator">
    <span>or</span>
  </Styled.Separator>
);
